import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ForgotId } from '../../../components/auth/tab.forgotId';
import { ForgotPassword } from '../../../components/auth/tab.forgotPassword';
import { FORGOT_TAB_MENU } from '../../../utils/menu';
import { useLocation } from 'react-router-dom';

interface LocationState {
  auth?: string;
}

const ForgotAccount = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const location = useLocation<LocationState>();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tab = parseInt(queryParams.get('tab') ?? '0', 10);
    setCurrentTab(tab);
  }, [location]);

  const selectMenuHandler = (index: number) => {
    setCurrentTab(index);
  };

  return (
    <Container>
      <TabBox>
        <TabMenu>
          {FORGOT_TAB_MENU.map((item, index) => (
            <li
              key={index}
              onClick={() => selectMenuHandler(index)}
              className={index === currentTab ? 'active' : ''}
            >
              {item}
            </li>
          ))}
        </TabMenu>
        <TabContents>
          {currentTab === 0 ? (
            <ForgotId selectMenuHandler={selectMenuHandler} />
          ) : null}
          {currentTab === 1 ? <ForgotPassword /> : null}
        </TabContents>
      </TabBox>
    </Container>
  );
};

export default ForgotAccount;

// style
const Container = styled.div`
  padding: 0 1.5rem;
`;

const TabBox = styled.div``;

const TabMenu = styled.ul`
  border-bottom: 1px solid ${(props) => props.theme.gray300};
  margin-top: -1.2rem;
  display: flex;
  li {
    flex-basis: 12.6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.4rem;
    font-size: 1.6rem;
    font-weight: 500;
    color: ${(props) => props.theme.textAAAColor};
    &.active {
      color: black;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: -2px;
        height: 2px;
        width: 100%;
        background-color: black;
      }
    }
  }
`;

const TabContents = styled.div`
  margin-top: 6rem;
  padding: 0 0.5rem;
`;
